import { createContext, useContext } from "react";
import { CrudAPI } from "./crud";
import { Dto } from "../../app/parts/crud/dto";
import { useParams } from "react-router-dom";

type CrudContextProos = {
  library?: CrudAPI | null,
  api?: string
}

const initCrudContextProosState = {
  library: null,
  api: ""
}

const CrudContext = createContext<CrudContextProos>(initCrudContextProosState);

export const useCrud = () => {
  return useContext(CrudContext)
}

export const CrudProvider = ({children, api}:any) => {
    let dtoRepo = require('./dtoRepo').dtoRepo;
    let dto = new Dto();
    if(dtoRepo[api] != undefined){
      dto = new dtoRepo[api]();
    }

   
    return (
      <CrudContext.Provider value={{library: new CrudAPI(api, dto), api}}>
        {children}
      </CrudContext.Provider>
    )
  
  
}